import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AtomicNameAndAvatarComponent } from '../../private/abstract-components/atomic/atomic.name-avatar.component';
import type { AtomicComponentType } from '../../private/utils/types.private';
import { TranslatedNameService } from '../services/translated-name-service';

/**
 * Example usage:
 * ```html
<plugins-user-name [userProvider]="providedUser" />
<plugins-user-name [userId]="id" />
<plugins-user-name [userId]="id" [size]="25px" />
``` */
@Component({
  selector: 'plugins-user-name',
  standalone: false,
  templateUrl: './user-name.component.html',
  styleUrl: './user-name.component.scss',
  providers: [TranslatedNameService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserNameComponent extends AtomicNameAndAvatarComponent {
  readonly lineLimit = input(1);

  override componentType: AtomicComponentType = 'userName';
  getInitials() {
    return '';
  }
  avatarLabelBackground(): { backgroundColor: string } {
    return { backgroundColor: '' };
  }
}
